import styled from "styled-components";

import { setFontVariant, colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

import { DefaultContentContainer } from "app/UtilitiesAndConstants/UtilitiesComponents/FadeWrapper";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon, blue, red } = colorsPalettes;

export type CellStateType = "default" | "error";

export const DomainsContainer = styled.div`
    height: 100%;
`;

export const SelectedDomainsListContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: start;
    height: calc(100% - 37px);
    margin-bottom: 5px;
`;
export const DomainsCounterContainer = styled.span`
    ${setFontVariant("body2", carbon[300])};
    font-style: normal;
    font-weight: normal;
    margin-bottom: 24px;
`;

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const Title = styled.div`
    ${setFontVariant("h4", carbon[400])};
`;

export const StyledFadeWrapper = styled(DefaultContentContainer)`
    height: calc(100vh - 370px); /* prevent height overflow when list is long */
`;

export const DomainItem = styled.div`
    display: flex;
    line-height: 16px;
    flex-grow: 1;
    justify-content: start;
    align-items: center;
    overflow: hidden;
`;

export const DomainItemContainer = styled.div<{ state?: CellStateType }>`
    border-bottom: 1px solid ${carbon[50]};
    display: flex;
    width: 100%;
    padding: 0 0 0 16px;
    overflow: hidden;
    background-color: ${({ state }) => (state === "error" ? red[100] : "transparent")};
`;

export const StyledIconButton = styled(IconButton)`
    min-width: 40px;

    .SWReactIcons {
        display: flex;
        justify-content: center;
        align-items: center;

        svg {
            width: 20px;
            height: 20px;
        }
    }
`;

export const DomainRowContainer = styled.div<{ isNewDomain: boolean }>`
    position: relative;
    display: flex;
    flex-grow: 1;
    align-items: center;
    ${({ isNewDomain }) =>
        isNewDomain &&
        `
    animation-name: backgroundAnimation;
    animation-duration: 4s;
    border-radius: 3px;
    @keyframes backgroundAnimation {
        from {background-color: ${blue[100]};}
        to {background-color: transparent;}
    }
    `}
`;

export const FadeWrapperContainer = styled.div`
    height: 100%;
`;

export const LoadersWrapper = styled(FlexColumn)`
    height: 180px;
`;

export const LoadersListItemWrapper = styled(FlexColumn)`
    height: 120px;
`;
